module.exports = __webpack_public_path__ + "img/Girl_03.6b1bb010.png";